<template>
  <base-modal
    :is-visible="isVisible"
    :is-deletable="true"
    @hideModal="hideModal()"
    @archiveItem="archiveItem()"
    @editItem="editItem()"
    @deleteItem="deleteItem()"
  >
    <template #header>
      {{$t('views.excmnote.show.title')}}
    </template>
    <template #body>
      <Show :note-id="iri"></Show>
    </template>
  </base-modal>
</template>

<script>
import BaseModal from '@/components/BaseComponents/BaseModal'
import { mapActions, mapGetters, mapMutations } from 'vuex'
import getIdFromLink from '@/utils/getIdFromLink'
import Show from '@/components/Dashboard/Views/excmnote/Show'

export default {
  name: 'ShowModal',
  components: {
    BaseModal,
    Show
  },
  props: ['iri'],
  created () {
    // this.retrieve(this.iri)
  },
  computed: {
    ...mapGetters({
      isVisible: 'excmnote/showModal/isVisible',
      deleteError: 'excmnote/del/error',
      error: 'excmnote/show/error',
      isLoading: 'excmnote/show/isLoading',
      item: 'excmnote/show/retrieved'
    })
  },
  methods: {
    editItem (item) {
      this.toggleModal()
      this.$router.push({ name: 'EXCMNoteUpdate', params: { id: this.item['@id'] } })
    },
    archiveItem (item) {
      this.$Swal({
        title: this.$t('notifications.archiveTitle') + ' ' + this.$t('notifications.archiveDescription'),
        type: 'question',
        showConfirmButton: true,
        confirmButtonText: this.$t('buttons.yes'),
        showCancelButton: true,
        cancelButtonText: this.$t('buttons.cancel')
      }).then((result) => {
        if (result) {
          this.$http
            .put('api/e_x_c_m_notes/' + getIdFromLink(this.item['@id']), {
              state: 0
            })
            .then(response => {
              this.hideModal()
              this.$Swal({ // show notification with success
                type: 'success',
                title: this.$t('notifications.update.updatedTitle'),
                showConfirmButton: false,
                timer: 2500
              })
            })
            .catch(error => {
              if (error.response.status === 400) {
                let text = ''
                for (let i in error.response.data) {
                  text += error.response.data[i] + '\n'
                }
                this.$Swal({
                  type: 'warning',
                  title: text,
                  timer: 2500
                })
              }
              console.log(error)
            })
        }
      })
    },
    deleteItem (item) {
      this.$Swal({
        title: this.$t('notifications.deleteTitle'),
        text: this.$t('notifications.deleteDescription'),
        type: 'warning',
        showCancelButton: true,
        confirmButtonText: this.$t('buttons.yes'),
        cancelButtonText: this.$t('buttons.no')
      }).then(response => {
        this.del(this.item).then(() => this.hideModal())
        this.$Swal({
          title: this.$t('notifications.deletedTitle'),
          type: 'success'
        })
      }, dismiss => {
        // dismiss can be 'overlay', 'cancel', 'close', 'esc', 'timer'
        if (dismiss === 'cancel') {
          this.$Swal({
            title: this.$t('notifications.deleteCancel'),
            type: 'error'
          })
        }
      })
    },
    hideModal () {
      this.reset()
      this.toggleModal()
    },
    ...mapMutations({
      toggleModal: 'excmnote/showModal/toggleModal'
    }),
    ...mapActions({
      del: 'excmnote/del/del',
      reset: 'excmnote/show/reset',
      retrieve: 'excmnote/show/retrieve'
    })
  }
}
</script>

<style scoped>

</style>
